export enum PageDirections {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}
